import { lazy } from "react";

const SignInSocial = lazy(() => import("../pages/signInUp/signIn/Social")); // 소셜 로그인
const SignInEmail = lazy(() => import("../pages/signInUp/signIn/Email")); // 이메일 로그인
const SignUpStep1 = lazy(() => import("../pages/signInUp/signUp/Step1")); // 회원가입 1단계
const SignUpStep2 = lazy(() => import("../pages/signInUp/signUp/Step2")); // 회원가입 2단계
const SignUpStep3 = lazy(() => import("../pages/signInUp/signUp/Step3")); // 회원가입 3단계
const SignUpStep4 = lazy(() => import("../pages/signInUp/signUp/Step4")); // 회원가입 4단계
const SignUpStep5 = lazy(() => import("../pages/signInUp/signUp/Step5")); // 회원가입 5단계
const SignUpComplete = lazy(() => import("../pages/signInUp/signUp/Complete")); // 회원가입 완료
const SignUpAdditional1 = lazy(() => import("../pages/signInUp/signUp/Additional1")); // 추가정보 1단계
const SignUpAdditional2 = lazy(() => import("../pages/signInUp/signUp/Additional2")); // 추가정보 2단계
const FindID = lazy(() => import("../pages/signInUp/findID/FindID")); // 아이디 찾기
const FindIDResult = lazy(() => import("../pages/signInUp/findID/FindIDResult")); // 아이디 찾기 결과
const FindPW = lazy(() => import("../pages/signInUp/findPW/FindPW")); // 비밀번호 찾기
const FindPWResult = lazy(() => import("../pages/signInUp/findPW/FindPWResult")); // 비밀번호 찾기 결과
const SignInUpApple = lazy(() => import("../pages/signInUp/signIn/AppleLogin")); // 애플 로그인
const SignInUpNaver = lazy(() => import("../pages/signInUp/signIn/NaverLogin")); // 네이버 로그인
const SignInUpKakao = lazy(() => import("../pages/signInUp/signIn/KakaoLogin")); // 카카오 로그인
const RedirectPage = lazy(() => import("../pages/signInUp/redirect/Social")); // Redirect
const WeddinghallOnboarding = lazy(
  () => import("../pages/signInUp/onboarding/WeddinghallOnboarding"),
);
const SelectHallStyle = lazy(() => import("../pages/signInUp/onboarding/SelectHallStyle")); // 웨딩홀 스타일 선택

export const authRoutes = [
  { path: "/sign-in/social", element: <SignInSocial /> },
  { path: "/sign-in/email", element: <SignInEmail /> },
  { path: "/sign-up/1", element: <SignUpStep1 /> },
  { path: "/sign-up/2", element: <SignUpStep2 /> },
  { path: "/sign-up/3", element: <SignUpStep3 /> },
  { path: "/sign-up/4", element: <SignUpStep4 /> },
  { path: "/sign-up/5", element: <SignUpStep5 /> },
  { path: "/sign-up/complete", element: <SignUpComplete /> },
  { path: "/sign-additional/1", element: <SignUpAdditional1 /> },
  { path: "/sign-additional/2", element: <SignUpAdditional2 /> },
  { path: "/find-id", element: <FindID /> },
  { path: "/find-id/complete", element: <FindIDResult /> },
  { path: "/find-pw", element: <FindPW /> },
  { path: "/find-pw/complete", element: <FindPWResult /> },
  { path: "/social/apple", element: <SignInUpApple /> },
  { path: "/social/naver", element: <SignInUpNaver /> },
  { path: "/social/kakao", element: <SignInUpKakao /> },
  { path: "/social/redirect", element: <RedirectPage /> },
  { path: "/onboarding/weddinghall", element: <WeddinghallOnboarding /> },
  { path: "/onboarding/hall-style", element: <SelectHallStyle /> },
];
